import React from "react";
import AutocompleteSelect from "../AutocompleteSelect";
import * as doc from "./doctor.mjs";

const anyDoctorOption = { id: "any", name: "Libovolný lékař" };

export default function DoctorsInput({
  doctorOptions,
  selectedService,
  selectedDoctors,
  setSelectedDoctors,
}) {
  const extendedDoctorOptions = React.useMemo(() => {
    if (doctorOptions.loading) {
      return doctorOptions.options;
    }

    return [anyDoctorOption, ...doctorOptions.options];
  }, [doctorOptions]);

  const selectedDoctorsValue = React.useMemo(() => {
    if (selectedDoctors.any) {
      return [anyDoctorOption];
    }

    return selectedDoctors.doctors;
  }, [selectedDoctors]);

  return (
    <AutocompleteSelect
      required={selectedService?.requires_doctor ?? false}
      multiple
      name="personel_id"
      loading={doctorOptions.loading}
      options={extendedDoctorOptions}
      label="Lékař"
      value={selectedDoctorsValue}
      onChange={(value) => {
        const first = value.at(0);
        const last = value.at(-1);

        if (value.length === 0) {
          if (selectedService?.requires_doctor) {
            setSelectedDoctors(doc.selectAnyDoctor());
          } else {
            setSelectedDoctors(doc.selectDoctors([]));
          }
        } else if (last.id === "any") {
          setSelectedDoctors(doc.selectAnyDoctor());
        } else if (first.id === "any") {
          setSelectedDoctors(doc.selectDoctors(value.slice(1)));
        } else {
          setSelectedDoctors(doc.selectDoctors(value));
        }
      }}
    />
  );
}
